/**
  * @class meleActorMarked
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-marked>` custom web element for showing active markers
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  ets: { description: 'event timestamp - current playback time in miliseconds', type: 'integer' },
  marker: {
    type: 'boolean',
    description: 'if true, marker is on',
  },
  lightbar: {
    type: 'boolean',
    description: 'if true, lightbar is on',
  },
  siren: {
    type: 'boolean',
    description: 'if true, siren is on',
  },
}, meleActor._properties)

export default class meleActorMarked extends meleActor {
  init() {
    super.init()
    this.markers = {}
    this.innerHTML = `
      <span class="marker"></span>
      <span class="lightbar"></span>
      <span class="siren"></span>
      `
  }

  message({ action, params }) {
    if(action==='mmMarked') {
      const sec = Math.floor(params?.event_dt / 1_000_000)
      if(!sec) return
      const id = params?.id || ''
      const type = params?.type || 'marker'
      this.markers[id] = { type, sec }
      this.refreshMarkers()
    }else if(action==='mmMarkStop') {
      const id = params?.id || ''
      delete this.markers[id]
      this.refreshMarkers()
    }
  } // message

  async etsChanged(ets) {
    const sec = Math.floor(ets / 1_000_000)
    if(this.current_sec === sec) return
    this.current_sec = sec
    this.refreshMarkers()
  } // etsChanged

  refreshMarkers() {
    const turned_on = {}
    const now = this.current_sec || 0
    for(const id in this.markers) {
      const marker = this.markers[id]
      const { type, sec } = marker
      if(sec > now + 1 || sec < now - 1) {
        delete this.markers[id]
        continue
      }
      turned_on[type] = true
    }
    this.marker = !!turned_on.marker
    this.lightbar = !!turned_on.lightbar
    this.siren = !!turned_on.siren
  }
} // class meleActorMarked

meleActorMarked._properties = PROPERTIES
meleActorMarked.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-marked', meleActorMarked)
